module.exports = __webpack_public_path__ + "deb6835b.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/milk.png
// module id = 691
// module chunks = 2